import React from "react";
import { Icon } from "@chakra-ui/react";
import Tooltip from "rc-tooltip";

type Props = {
	icon: string;
	iconSize: number;
	label: string;
	onClick: () => void;
	dataTestId: string;
};

export function ClassroomTileButton(props: Props): JSX.Element {
	return (
		<Tooltip
			placement="top"
			trigger={["hover", "focus"]}
			destroyTooltipOnHide={true}
			overlayClassName="Tooltip"
			overlay={<span>{props.label}</span>}
		>
			<button aria-label={props.label} className="classroom_tile_button" onClick={props.onClick} data-testid={props.dataTestId}>
				<Icon className={props.icon} width={props.iconSize} />
			</button>
		</Tooltip>
	);
}
